import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  InputGroup,
  Badge,
  Dropdown,
  Spinner,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faSearch,
  faEdit,
  faEye,
  faSort,
  faDownload,
  faEllipsisV, faSync
} from '@fortawesome/free-solid-svg-icons'
import { Link, useParams, useHistory } from 'react-router-dom'
import { DebounceInput } from 'react-debounce-input'
import * as InvoiceController from '../Controller/InvoiceController'
// import { toast } from 'react-toastify'
import Pagination from '../../../../GlobalModules/Utility/Components/Pagination'
import Utility from '../../../../GlobalModules/Utility/Utility'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import '../Assets/css/invoice.scss'

const InvoiceList = (props) => {
  const { lng } = useParams()
  const history = useHistory()
  const [invoices, setInvoices] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [sortField, setSortField] = useState('invoice_number')
  const [sortDirection, setSortDirection] = useState('desc')
  const [loading, setLoading] = useState(true)
  const [totalItems, setTotalItems] = useState(0)
  const [selectedRange, setSelectedRange] = useState('all')

  // Function to open PDF with actions (Print and Download buttons)
  const openPdfWithActions = async (invoiceSlack) => {
    try {
      const res = await InvoiceController.getInvoiceApi(invoiceSlack)
      if (res.success) {
        const invoice = res.data
        const pdfUrl = invoice?.order?.invoice_pdf_url || invoice?.invoice_pdf_url;

        if (!pdfUrl) {
          alert('Invoice PDF URL not available');
          return;
        }

        // Open new window for PDF
        const pdfWindow = window.open('', '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes')

        // Create HTML with embedded PDF and action buttons
        pdfWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Invoice ${invoice?.invoice_number || ''}</title>
                <style>
                    @media print {
                        .d-print-none { 
                            display: none !important; 
                        }
                    }
                    
                    body { 
                        margin: 0; 
                        padding: 0; 
                        font-family: Arial, sans-serif;
                        display: flex;
                        flex-direction: column;
                        height: 100vh;
                    }
                    
                    .button-container {
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        padding: 15px;
                        background-color: #f8f9fa;
                        border-bottom: 1px solid #dee2e6;
                    }
                    
                    .btn {
                        padding: 10px 20px;
                        font-size: 14px;
                        font-weight: 500;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        transition: all 0.2s;
                    }
                    
                    .btn-primary {
                        background-color: #6c757d;
                        color: white;
                    }
                    
                    .btn-primary:hover {
                        background-color: #5a6268;
                    }
                    
                    .btn-success {
                        background-color: #28a745;
                        color: white;
                    }
                    
                    .btn-success:hover {
                        background-color: #218838;
                    }
                    
                    .pdf-container {
                        flex: 1;
                        width: 100%;
                        overflow: hidden;
                    }
                    
                    iframe {
                        width: 100%;
                        height: 100%;
                        border: none;
                    }
                </style>
            </head>
            <body>
                <div class="button-container d-print-none">
                    <button class="btn btn-primary" onclick="window.print()">
                        <span>🖨️</span> Print Invoice
                    </button>
                    <button class="btn btn-success" onclick="downloadPDF()">
                        <span>📄</span> Download as PDF
                    </button>
                </div>
                <div class="pdf-container">
                    <iframe src="${pdfUrl}" type="application/pdf"></iframe>
                </div>
                <script>
                    async function downloadPDF() {
                        try {
                            const response = await fetch('${pdfUrl}');
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'Invoice_${invoice?.invoice_number || 'invoice'}.pdf';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                        } catch (error) {
                            console.error('Error downloading PDF:', error);
                            // Fallback to direct link if fetch fails
                            const link = document.createElement('a');
                            link.href = '${pdfUrl}';
                            link.download = 'Invoice_${invoice?.invoice_number || 'invoice'}.pdf';
                            link.target = '_blank';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }
                </script>
            </body>
            </html>
        `)
        pdfWindow.document.close()
        pdfWindow.focus()
      } else {
        alert('Failed to fetch invoice details')
      }
    } catch (error) {
      console.error('Error opening PDF:', error)
      alert('Error opening PDF')
    }
  }
  const [filters, setFilters] = useState({
    limit: 10,
    offset: 0,
    sort: [
      {
        field: 'invoice_number',
        sort: 'desc'
      }
    ],
    search: '',
    from_created_date: '',

    to_created_date: ''
  })
  const suppressNextFetchRef = useRef(false)
  // const prevSearchLenRef = useRef(0)
  const [deletingSlack, setDeletingSlack] = useState(null)

  const setQuickRange = (type) => {
    const today = new Date()
    let from = ''
    let to = ''

    const fmt = (d) => d.toISOString().split('T')[0]

    switch (type) {
      case 'today':
        from = fmt(today)
        to = fmt(today)
        break
      case 'yesterday': {
        const y = new Date(today)
        y.setDate(y.getDate() - 1)
        from = fmt(y)
        to = fmt(y)
        break
      }
      case 'last7': {
        const f = new Date(today)
        f.setDate(f.getDate() - 6)
        from = fmt(f)
        to = fmt(today)
        break
      }
      case 'lastMonth': {
        const f = new Date(today)
        f.setDate(f.getDate() - 29)
        from = fmt(f)
        to = fmt(today)
        break
      }
      case 'all':
        from = ''
        to = ''
        break
      default:
        break
    }

    setFilters((prev) => ({
      ...prev,
      from_created_date: from,
      to_created_date: to,
      offset: 0
    }))
    setSelectedRange(type)
  }

  // Removed top-level date filter handlers; custom dates are controlled inline below

  // const startIndex = totalItems === 0 ? 0 : filters.offset + 1
  // const endIndex =
  //   totalItems === 0
  //     ? 0
  //     : Math.min(filters.offset + invoices.length, totalItems)

  const handleLimitChange = (limit) => {
    const newLimit = parseInt(limit)
    setItemsPerPage(newLimit)
    setCurrentPage(1)
    setFilters((prev) => ({
      ...prev,
      limit: newLimit,
      offset: 0
    }))
  }


  const handleExportInvoices = useCallback(async () => {
    try {
      setLoading(true)
      const exportData = {
        from_created_date: filters.from_created_date,
        to_created_date: filters.to_created_date,
        store_id: localStorage.getItem('store_id')
      }
      const response = await InvoiceController.exportInvoicesApi(exportData)
      if (response && response.success && response.data) {
        if (response.isFileUrl) {
          await Utility.downloadFile(
            response.data,
            response.filename || 'invoices_export.xlsx'
          )
        } else {
          const blob = new Blob([response.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = response.filename || 'invoices_export.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
      }
    } catch (error) {
      console.error('Error exporting invoices', error)
    } finally {
      setLoading(false)
    }
  }, [filters])

  const handleAddInvoice = useCallback(() => {
    history.push(`/${lng}/sales/invoices/add`)
  }, [history, lng])

  const handleQuickRangeClick = useCallback((e) => {
    const range = e.currentTarget.getAttribute('data-range')
    if (range === 'all') return setQuickRange('all')
    if (range === 'today') return setQuickRange('today')
    if (range === 'yesterday') return setQuickRange('yesterday')
    if (range === 'last7') return setQuickRange('last7')
    if (range === 'lastMonth') return setQuickRange('lastMonth')
    if (range === 'custom') setSelectedRange('custom')
  }, [])

  const handleRefresh = () => {
    performFetch(filters)
  }

  const performFetch = useCallback(
    async (effectiveFilters) => {
      try {
        setLoading(true)
        if (props.userEntryType?.user_type === 'staff') {
          if (localStorage.getItem('store_id') == null) {
            localStorage.setItem('store_id', props.userEntryType.branch_id)
          }
        }

        const response = await InvoiceController.getInvoicesApi(
          effectiveFilters
        )
        if (response.success) {
          const rows = response.data || []
          setInvoices(rows)
          setTotalItems(response.total || rows.length)
        } else {
          setInvoices([])
        }
      } catch (error) {
        console.error('Error fetching invoices:', error)
        setInvoices([])
      } finally {
        setLoading(false)
      }
    },
    [props.userEntryType]
  )

  const fetchInvoices = useCallback(async () => {
    await performFetch(filters)
  }, [filters, performFetch])

  // Auto-fetch when both custom dates are set
  useEffect(() => {
    if (
      selectedRange === 'custom' &&
      filters.from_created_date &&
      filters.to_created_date
    ) {
      performFetch({ ...filters })
    }
  }, [selectedRange, filters, performFetch])

  useEffect(() => {
    if (suppressNextFetchRef.current) {
      suppressNextFetchRef.current = false
      return
    }
    fetchInvoices()
  }, [fetchInvoices])

  const getCreatedDisplay = (row) => {
    const value =
      row.createdAt || row.created_at || row.createdAt_label || row.created_on
    return value ? Utility.get12HourFormat(value) : 'N/A'
  }

  const getUpdatedDisplay = (row) => {
    const value =
      row.updatedAt || row.updated_at || row.updatedAt_label || row.updated_on
    return value ? Utility.get12HourFormat(value) : 'N/A'
  }

  const handleSearch = (e) => {
    const raw = e.target.value || ''
    const clean = raw.replace(/\s+/g, '')
    setSearchTerm(clean)
    setCurrentPage(1)
    const next = {
      ...filters,
      search: clean.length >= 2 ? clean : '',
      offset: 0
    }
    suppressNextFetchRef.current = true
    setFilters(next)
    if (clean.length >= 2 || clean.length === 0) {
      performFetch(next)
    }
  }

  // const handleSearchEnter = (e) => {
  //   if (e.key === ' ') {
  //     e.preventDefault()
  //     return
  //   }
  //   if (e.key === 'Enter') {
  //     const raw = e.target.value
  //     const value = raw.replace(/\s+/g, '')
  //     setSearchTerm(value)
  //     setCurrentPage(1)
  //     setFilters((prev) => ({
  //       ...prev,
  //       search: value,
  //       offset: 0
  //     }))
  //   }
  // }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilters((prev) => ({
      ...prev,
      offset: (page - 1) * prev.limit
    }))
  }

  const handleSort = (field) => {
    let newSortDirection = 'asc'
    if (sortField === field) {
      newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc'
    } else {
      setSortField(field)
    }
    setSortDirection(newSortDirection)
    setFilters((prev) => ({
      ...prev,
      sort: [
        {
          field: field,
          sort: newSortDirection
        }
      ]
    }))
  }

  const resolveSentLabel = (label, billTo) => {
    if (label === 'Sent') {
      if (billTo === 'SUPPLIER') return 'Received'
      if (billTo === 'CUSTOMER') return 'Sent'
      return ''
    }
    return label
  }

  const getStatusBadge = (status, statusData, billTo) => {
    if (statusData && statusData.label) {
      const label = resolveSentLabel(statusData.label, billTo)
      const colorClass = statusData.color || ''
      // Map backend label colors to bootstrap
      let bg = 'secondary'
      if (colorClass.includes('green')) bg = 'success'
      else if (colorClass.includes('blue')) bg = 'primary'
      else if (colorClass.includes('yellow') || colorClass.includes('warning'))
        bg = 'warning'
      else if (colorClass.includes('red') || colorClass.includes('danger'))
        bg = 'danger'
      return <Badge bg={bg}>{label}</Badge>
    }
    // Fallback to numeric status
    const statusMap = {
      0: { label: 'Draft', bg: 'secondary' },
      1: { label: 'New', bg: 'primary' },
      2: { label: 'Sent', bg: 'info' },
      3: { label: 'Paid', bg: 'success' },
      4: { label: 'Overdue', bg: 'warning' }
    }
    const statusInfo = statusMap[status] || { label: 'Unknown', bg: 'primary' }
    const resolvedLabel = resolveSentLabel(statusInfo.label, billTo)
    return <Badge bg={statusInfo.bg}>{resolvedLabel}</Badge>
  }

  const hasInvoicePermission = () => {
    const invoicePermission = Utility.getRoleObjectBySubEventKey('sales_and_orders', 'invoices');
    if (invoicePermission.length > 0) {
      const rules = invoicePermission[0].rules;
      return rules === "CRUD" || rules === "CUD";
    }
    return false;
  };

  //======= add action permission ====//
  // Check multiple permissions at once
  const invoicesPermissions = Utility.hasMultipleActionPermissions(
    'sales_and_orders',
    'invoices',
    ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'generate_invoice', 'change_status', 'print_invoice'],
    props.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
  );

  // Check if any actions are available for display in the table
  const hamburgerTableActions = invoicesPermissions.edit || invoicesPermissions.delete || invoicesPermissions.print_invoice;

  return (
    <Container fluid className='p-0'>
      <div className='d-flex justify-content-between align-items-center top-header-box'>
        <h4>Invoices</h4>
        <div className='orderBox'>
          {invoicesPermissions.export && (
            <Button
              variant='outline-secondary'
              className='me-2'
              onClick={handleExportInvoices}
            >
              <FontAwesomeIcon icon={faDownload} className='me-2' /> Download
            </Button>

          )}
          {invoicesPermissions.create && hasInvoicePermission() && (
            <Button variant='primary' onClick={handleAddInvoice} style={{ display: 'none' }}>
              <FontAwesomeIcon icon={faPlus} className='me-2' /> New Invoice
            </Button>
          )}
        </div>
      </div>

      <Card className='custom-border-light'>
        <Card.Body>
          {/* Removed top-level From/To/Search block; use Custom Dates inline with quick filters */}
          <Row className='mb-3 gx-2 searchBarPanel'>
            <Col className='d-flex align-items-center flex-wrap gap-2 innSearchBarPanel'>
              {selectedRange === 'custom' && (
                <div className='d-flex align-items-center gap-2'>
                  <input
                    type='date'
                    className='form-control form-control-sm'
                    placeholder='dd.mm.yyyy'
                    value={filters.from_created_date}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        from_created_date: e.target.value,
                        offset: 0
                      }))
                    }
                    style={{ width: 160 }}
                  />
                  <span>to</span>
                  <input
                    type='date'
                    className='form-control form-control-sm'
                    placeholder='dd.mm.yyyy'
                    min={filters.from_created_date || undefined}
                    value={filters.to_created_date}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        to_created_date: e.target.value,
                        offset: 0
                      }))
                    }
                    style={{ width: 160 }}
                  />
                </div>
              )}
              <div className='btn-group ms-auto'>
                <Button
                  size='sm'
                  variant={selectedRange === 'today' ? 'primary' : 'light'}
                  data-range='today'
                  onClick={handleQuickRangeClick}
                >
                  Today
                </Button>
                <Button
                  size='sm'
                  variant={selectedRange === 'yesterday' ? 'primary' : 'light'}
                  data-range='yesterday'
                  onClick={handleQuickRangeClick}
                >
                  Yesterday
                </Button>
                <Button
                  size='sm'
                  variant={selectedRange === 'last7' ? 'primary' : 'light'}
                  data-range='last7'
                  onClick={handleQuickRangeClick}
                >
                  Last 7 days
                </Button>
                <Button
                  size='sm'
                  variant={selectedRange === 'lastMonth' ? 'primary' : 'light'}
                  data-range='lastMonth'
                  onClick={handleQuickRangeClick}
                >
                  Last Month
                </Button>
                <Button
                  size='sm'
                  variant={selectedRange === 'custom' ? 'primary' : 'light'}
                  data-range='custom'
                  onClick={handleQuickRangeClick}
                >
                  Custom Dates
                </Button>
                <Button
                  size='sm'
                  variant={selectedRange === 'all' ? 'primary' : 'light'}
                  data-range='all'
                  onClick={handleQuickRangeClick}
                >
                  All
                </Button>
              </div>
              <div className='searchFieldBoxes'>
                <div className='ms-2 searchFieldBox searchFieldBoxCustom'>
                  <InputGroup size='sm'>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <DebounceInput
                      minLength={1}
                      debounceTimeout={500}
                      className='form-control invoice-search-input'
                      placeholder='Search by Invoice No, Reference, Bill to name'
                      value={searchTerm || ''}
                      onChange={(e) => handleSearch(e)}
                      onKeyDown={(e) => {
                        if (e.key === ' ') e.preventDefault()
                      }}
                    />
                    
                  </InputGroup>
                </div>

                <div className='ms-2'>
                  <Button
                    variant='outline-secondary'
                    size='sm'
                    onClick={handleRefresh}
                    disabled={loading}
                    title='Refresh'
                  >
                    <FontAwesomeIcon
                      icon={faSync}
                      spin={loading}
                    />
                  </Button>
                </div>
              </div>


              {/* Custom Dates removed per request */}
            </Col>
          </Row>

          <div className='table-responsive'>
            <Table hover className='align-middle invoice-list-table'>
              <thead>
                <tr>
                  <th
                    onClick={() => handleSort('invoice_number')}
                    style={{ cursor: 'pointer' }}
                  >
                    Invoice No.{' '}
                    {sortField === 'invoice_number' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('invoice_reference')}
                    style={{ cursor: 'pointer' }}
                  >
                    Ref. #{' '}
                    {sortField === 'invoice_reference' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('store_name')}
                    style={{ cursor: 'pointer' }}
                  >
                    Store{' '}
                    {sortField === 'store_name' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('bill_to')}
                    style={{ cursor: 'pointer' }}
                  >
                    Bill To{' '}
                    {sortField === 'bill_to' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('bill_to_name')}
                    style={{ cursor: 'pointer' }}
                  >
                    Bill To Name{' '}
                    {sortField === 'bill_to_name' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('invoice_date')}
                    style={{ cursor: 'pointer' }}
                  >
                    Inv. Date{' '}
                    {sortField === 'invoice_date' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('invoice_due_date')}
                    style={{ cursor: 'pointer' }}
                  >
                    Due Date{' '}
                    {sortField === 'invoice_due_date' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('total_order_amount')}
                    style={{ cursor: 'pointer' }}
                  >
                    Amount{' '}
                    {sortField === 'total_order_amount' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('status')}
                    style={{ cursor: 'pointer' }}
                  >
                    Status{' '}
                    {sortField === 'status' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('created_at')}
                    style={{ cursor: 'pointer' }}
                  >
                    Created On{' '}
                    {sortField === 'created_at' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  {/* <th
                    onClick={() => handleSort('updated_at')}
                    style={{ cursor: 'pointer' }}
                  >
                    Updated On{' '}
                    {sortField === 'updated_at' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th> */}
                  <th
                    onClick={() => handleSort('created_by')}
                    style={{ cursor: 'pointer' }}
                  >
                    Created By{' '}
                    {sortField === 'created_by' && (
                      <FontAwesomeIcon icon={faSort} size='xs' />
                    )}
                  </th>
                  {hamburgerTableActions && (
                    <th>Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={hamburgerTableActions ? 12 : 11} className='text-center py-4'>
                      {/* <Spinner animation='border' variant='primary' />
                      <span className='ms-2'>Loading invoices...</span> */}
                    </td>
                  </tr>
                ) : invoices.length > 0 ? (
                  invoices.map((inv) => {
                    return (
                      <tr 
                        key={inv.id}
                        onDoubleClick={() => {
                          if (inv.bill_to.toLowerCase() === 'customer') {
                            openPdfWithActions(inv.slack)
                          } else{
                            history.push(`/${lng}/sales/invoices/view/${inv.slack}`)
                          }
                        }}
                        className='cursor-pointer'
                      >
                        <td>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{inv.invoice_number}</Tooltip>}>
                            <span className="truncate-cell">{inv.invoice_number}</span>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <OverlayTrigger placement="top" overlay={<Tooltip>{inv.invoice_reference || 'N/A'}</Tooltip>}>
                            <span className="truncate-cell">{inv.invoice_reference || 'N/A'}</span>
                          </OverlayTrigger>
                        </td>
                        <td>{inv?.store?.name || '-'}</td>
                        <td>{inv.bill_to}</td>
                        <td>{inv.bill_to_name}</td>
                        <td>{inv.invoice_date}</td>
                        <td>{inv.invoice_due_date}</td>
                        <td>
                          {/*{parseFloat(inv.total_order_amount || 0).toFixed(2)}*/}
                          {/* { Math.floor(inv.total_order_amount || 0).toFixed(2)} */}
                          {Math.round(inv.total_order_amount_rounded || 0).toFixed(2)}
                        </td>
                        <td>{getStatusBadge(inv.status, inv.status_data, inv.bill_to)}</td>
                        <td>{getCreatedDisplay(inv)}</td>
                        {/* <td>{getUpdatedDisplay(inv)}</td> */}
                        <td>
                          {(() => {
                            const u = inv.created_by || inv.created_user
                            if (!u) return 'N/A'
                            if (typeof u === 'string') return u
                            return (
                              u.username ||
                              u.name ||
                              u.fullname ||
                              u.email ||
                              'N/A'
                            )
                          })()}
                        </td>
                        {hamburgerTableActions && (
                          <td>
                            <Dropdown align='end'>
                              <Dropdown.Toggle
                                variant='light'
                                size='sm'
                                id={`dropdown-${inv.id}`}
                                className='btn-icon no-caret'
                              >
                                <FontAwesomeIcon icon={faEllipsisV} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {
                                  inv.bill_to.toLowerCase() === 'customer' ? (
                                    <Dropdown.Item
                                      onClick={() => openPdfWithActions(inv.slack)}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        className='me-2'
                                      />{' '}
                                      View
                                    </Dropdown.Item>
                                  ) : (
                                    <Dropdown.Item
                                      as={Link}
                                      to={`/${lng}/sales/invoices/view/${inv.slack}`}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        className='me-2'
                                      />{' '}
                                      View
                                    </Dropdown.Item>
                                  )}
                                {/* Hide edit option if invoice has valid order_id */}
                                {!(inv.status === 3 || inv.order_id !== null) && invoicesPermissions.edit && (
                                  <Dropdown.Item
                                    as={Link}
                                    to={`/${lng}/sales/invoices/edit/${inv.slack}`}
                                  >
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      className='me-2'
                                    />{' '}
                                    Edit
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        )}
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={hamburgerTableActions ? 12 : 11} className='text-center py-4'>
                      {searchTerm
                        ? 'No invoices found matching your search.'
                        : 'No invoices found.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className='paginationSec'>
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              siblingCount={2}
              onLimitChange={handleLimitChange}
              limitOptions={[10, 25, 50, 100, 500, 1000]}
              showSummary={true}
              showLimit={true}
            />
          </div>
        </Card.Body>
      </Card>
    </Container>
  )
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    userEntryType: globalState.LoginReducer.userEntryType
  }
}

export default connect(mapStateToProps)(withNamespaces()(InvoiceList))
